<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import MapMain from '@/components/Sections/Map/MapMain.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const gameStore = useGameStore()
</script>

<template>
  <div class="content text-metal-300">
    <div ref="content" v-if="gameStore.websocketInitialSyncCompleted === true" class="flex h-full relative">
      <div class="flex-1 min-w-0 overflow-x-hidden overflow-y-auto">
        <div v-show="route.name?.toString().startsWith('Map')">
          <MapMain />
        </div>
        <router-view v-slot="{ Component, route }">
          <component v-if="!route.name?.toString().startsWith('Map')" :is="Component" />
        </router-view>
      </div>
    </div>
  </div>
</template>

<style scoped>
.content {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 5rem - var(--chat-height));
}

@media (max-width: 768px) {
  .content {
    height: calc((var(--vh, 1vh) * 100) - 5rem - var(--chat-height));
  }
}
</style>
